import {IMenuItemConfigReader} from "../../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {GenericUsefulLinksMenuItemRenderer} from "../generic-useful-links-menu-item-renderer";

export default class HybridInfoMenuItemRenderer extends GenericUsefulLinksMenuItemRenderer {
    constructor(configReader: IMenuItemConfigReader,
                services: IServiceFactoryExtended) {
        super('hybridInfoMenuItem', configReader, services);
    }
    protected _shouldDisplay(): boolean {
        return super._shouldDisplay() && this.services.hybrid.isDebugMode();
    }
}